namespace AgerLMS.LMS {
    export interface CourseFilterItemRow {
        Id?: number;
        CourseId?: number;
        FilterItemId?: number;
        CourseCourseName?: string;
        FilterItemFilterId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace CourseFilterItemRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.CourseFilterItem';
        export const deletePermission = 'LMS';
        export const insertPermission = 'LMS';
        export const readPermission = 'LMS';
        export const updatePermission = 'LMS';

        export declare const enum Fields {
            Id = "Id",
            CourseId = "CourseId",
            FilterItemId = "FilterItemId",
            CourseCourseName = "CourseCourseName",
            FilterItemFilterId = "FilterItemFilterId",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
